var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-dialog',{attrs:{"dialog":_vm.dialog},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('Btn',{attrs:{"color":"secondary","block":""},on:{"click":function($event){return _vm.dialog.close({})}}},[_vm._v(" "+_vm._s(_vm.$t("buttons.withoutNo.close"))+" ")])]},proxy:true}])},[_c('LessonWordsInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }